module.exports = __webpack_public_path__ + "img/founders_11.267e2d8f.jpg";